import vuetifyToast from 'vuetify-toast'
import { apiAxios } from '@/helpers'
const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'info',
    timeout: 2000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'files',
    model: 'file',
    loading: false,
  }
}

const state = initialState()

const actions = {
  async create({ commit, state }, payload) {
    commit('setLoading', true)
    let { data } = await apiAxios
      .post(state.module + '/create', payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
  },
  async delete({ commit, state }, id) {
    commit('setLoading', true)
    await apiAxios
      .delete(`${state.module}/${id}`)
      .finally(() => commit('setLoading', false))
  },
  async uploadFile({ commit }, payload) {
    commit('setLoading', true)
    let file = new FormData()
    file.append('file', payload.file)
    let objectId = payload.objectId
    let type = payload.type
    if (type) objectId += '/' + type
    const { data } = await apiAxios
      .post('/upload/file/' + objectId, file, {
        timeout: 0,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .finally(() => commit('setLoading', false))
    notify(data.message)
    return data.data.path
  },
  async uploadPush({ commit, dispatch }, payload) {
    commit('setLoading', true)
    let file = new FormData()
    file.append('file', payload.file)
    let { model, id, field } = payload

    const { data } = await apiAxios
      .post(`/upload/push/${model}/${id}/${field}`, file, {
        timeout: 0,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .finally(() => commit('setLoading', false))
    notify(data.message)
    if (model === 'Typeevents') {
      dispatch(`typeEvents/fetchList`, {}, { root: true })
    } else dispatch(`${model.toLowerCase()}/fetchList`, {}, { root: true })
  },
  async uploadGaleryFile({ commit, dispatch }, payload) {
    let userId = payload.userId
    commit('setLoading', true)
    let file = new FormData()
    file.append('file', payload.file)

    const { data } = await apiAxios
      .post('/upload/galery/' + userId, file, {
        timeout: 0,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .finally(() => commit('setLoading', false))
    dispatch('users/fetchOne', userId, { root: true })
    notify(data.message)
    return data.data.path
  },
  async deleteGaleryFile({ commit, dispatch }, payload) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .delete('/file/galery', { data: payload, timeout: 0 })
      .finally(() => commit('setLoading', false))
    dispatch('users/fetchOne', payload.userId, { root: true })
    notify(data.message)
    return data.data.path
  },
}

const mutations = {
  setLoading(state, payload) {
    state.loading = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
